
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useFetch } from '../../../services/transports';
import { searchStakeholdersDrug, DrugSaleToGLN } from '../../../api/stakeholder';
import { drugsModel } from '../../../constants';
import { LabeledSelect } from '..';

export const SearchStakeholdersDrug = ({
  isDrugSale = false, label, id, onChange, withAsterisks, fullValue,
  byUsername, setValueAsObject, value, inMyCompany = false, ...props }) => {

  const [ stakeholdersOptions, setStakeholdersOptions ] = useState([]);

  const [ { data }, fetchSearchStakeholdersDrug ] = useFetch(searchStakeholdersDrug,
    useCallback(response => response?.data?.container));


  const [ { data: dragSaleData }, fetchDrugSaleData ] = useFetch(DrugSaleToGLN,
    useCallback(response => response?.data?.container));


  const onSearchStakeholder = useCallback(query => {
    !isDrugSale
      ? !!query
    && fetchSearchStakeholdersDrug({ [drugsModel.GLN_OR_QUERY]: query.trim(), inMyCompany })
      : isDrugSale && fetchDrugSaleData();

  }, [ fetchSearchStakeholdersDrug ], [ fetchDrugSaleData ]);


  const [ t ] = useTranslation();

  useEffect(() => {
    let options = [];
    if (data.length > 0) {
      if (byUsername) {
        options = data.slice().map(item =>
          ({ value: `${item.username}`, text: `${item.username} ${item.gln}` }));
      } else {
        options = fullValue
          ? data.slice().map(item => ({
            value: `${item.shId} ^break^ ${item.gln} - ${item.name} `,
            text: `${item.gln} - ${item.name}` }))
          : data.slice().map(item => ({
            value: `${item.shId}`,
            text: `${item.gln} - ${item.name}`,
            item
          }));
      }
      setStakeholdersOptions(options);
    }
  }, [ data ]);

  useEffect(() => {

    let options = [];
    if (dragSaleData.length) {
      options = [
        { value: '0000000000000', text: t('fields.directSale') }, // as the old RSD
        ...dragSaleData.slice().map(item => ({ value: `${item.gln}`, text: `${item.name}` }))
      ];

      setStakeholdersOptions(options);
    }
  }, [ dragSaleData ]);


  return (
    <LabeledSelect
      setValueAsObject={ setValueAsObject }
      label={ label }
      id={ id }
      onChange={ onChange }
      showSearch={ true }
      withDebounceSearch={ true }
      onSearch={ onSearchStakeholder }
      searchDelay={ 1000 }
      options={ stakeholdersOptions }
      filterOption={ false }
      EmptyComponent={ t('ERR.noMatchedSH') }
      withAsterisks={ withAsterisks }
      placeholder={ t('fields.drug.search') }
      value={ value || undefined }
      { ...props }
    />
  );
};
